import React from "react";
import AboutSection from "../components/MainSection/AboutSection";
const About = () => {
  return (
    <div>
      <AboutSection></AboutSection>
    </div>
  );
};

export default About;
